$(function(){

    App.Slider = {

        init: function(){

            $('.js--slider-container').each(function(){

                const $container = $(this),
                    $slider = $('.js--slider', $container),
                    $prev = $('.js--slider-prev', $container),
                    $next = $('.js--slider-next', $container);

                if ($slider.hasClass('slick-initialized')) return;

                let slidesToShow = 1;
                if ($slider.attr('data-items') !== undefined) slidesToShow = Number($slider.attr('data-items'));
                let slidesToShowSM = slidesToShow;
                if ($slider.attr('data-items-sm') !== undefined) slidesToShowSM = Number($slider.attr('data-items-sm'));
                let slidesToShowMD = slidesToShowSM;
                if ($slider.attr('data-items-md') !== undefined) slidesToShowMD = Number($slider.attr('data-items-md'));
                let slidesToShowLG = slidesToShowMD;
                if ($slider.attr('data-items-lg') !== undefined) slidesToShowLG = Number($slider.attr('data-items-lg'));
                let slidesToShowXL = slidesToShowLG;
                if ($slider.attr('data-items-xl') !== undefined) slidesToShowXL = Number($slider.attr('data-items-xl'));

                let fade = false;
                if ($slider.attr('data-fade') == 'true') fade = true;

                let infinite = true;
                if ($slider.attr('data-infinite') == 'false') infinite = false;

                let dots = false;
                if ($slider.attr('data-dots') == 'true') dots = true;
                let dotsMD = dots;
                if ($slider.attr('data-dots-md') == 'true') dotsMD = true;
                else if ($slider.attr('data-dots-md') == 'false') dotsMD = false;

                let variableWidth = false;
                if ($slider.attr('data-variableWidth') == 'true') variableWidth = true;
                else if ($slider.attr('data-variableWidth') == 'false') variableWidth = false;
                let variableWidthSM = variableWidth;
                if ($slider.attr('data-variableWidth-sm') == 'true') variableWidthSM = true;
                else if ($slider.attr('data-variableWidth-sm') == 'false') variableWidthSM = false;
                let variableWidthMD = variableWidthSM;
                if ($slider.attr('data-variableWidth-md') == 'true') variableWidthMD = true;
                else if ($slider.attr('data-variableWidth-md') == 'false') variableWidthMD = false;
                let variableWidthLG = variableWidthMD;
                if ($slider.attr('data-variableWidth-lg') == 'true') variableWidthLG = true;
                else if ($slider.attr('data-variableWidth-lg') == 'false') variableWidthLG = false;
                let variableWidthXL = variableWidthLG;
                if ($slider.attr('data-variableWidth-xl') == 'true') variableWidthXL = true;
                else if ($slider.attr('data-variableWidth-xl') == 'false') variableWidthXL = false;

                let autoplay = false;
                let autoplaySpeed = 3000;
                if ($slider.attr('data-autoplaySpeed') !== undefined) {
                    autoplay = true;
                    autoplaySpeed = $slider.attr('data-autoplaySpeed');
                }

                let adaptiveHeight = false;
                if ($slider.attr('data-adaptiveHeight') == 'true') {
                    adaptiveHeight = true;
                }

                const sliderOptions = {
                    slidesToShow: slidesToShow,
                    prevArrow: $prev,
                    nextArrow: $next,
                    dots: dots,
                    fade: fade,
                    infinite: infinite,
                    variableWidth: variableWidth,
                    adaptiveHeight: adaptiveHeight,
                    autoplay: autoplay,
                    autoplaySpeed: autoplaySpeed,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 575,
                            settings: {
                                slidesToShow: slidesToShowSM,
                                variableWidth: variableWidthSM,
                                dots: dots
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: slidesToShowMD,
                                variableWidth: variableWidthMD,
                                dots: dotsMD
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: slidesToShowLG,
                                variableWidth: variableWidthLG,
                                dots: dotsMD
                            }
                        },
                        {
                            breakpoint: 1199,
                            settings: {
                                slidesToShow: slidesToShowXL,
                                variableWidth: variableWidthXL,
                                dots: dotsMD
                            }
                        }
                    ]
                };

                $slider.slick(sliderOptions);

                $slider.on('sliderReinit', function(){
                    $slider.slick('unslick').slick(sliderOptions);
                });

                if ($slider.hasClass('_overheight')) {
                    $slider.on('setPosition', function () {
                        $slider.find('.slick-slide').matchHeight();
                    });
                }

            });

        },

        variableWidthSliderMod: function($slider){

            let initialSlide = $slider.slick('slickCurrentSlide');

            function setDataLastSlide(){
                var sliderWidth = $slider.innerWidth(),
                    lastIndex = 0,
                    slidesWidth = 0;
                $('.slick-slide', $slider).each(function(){
                    slidesWidth += $(this).innerWidth();
                });
                if (sliderWidth < slidesWidth) {
                    $('.slick-slide', $slider).each(function(){
                        slidesWidth -= $(this).innerWidth();
                        lastIndex += 1;
                        if (slidesWidth <= sliderWidth) return false;
                    });
                }
                $slider.attr('data-last-slide', lastIndex);
            }
            setDataLastSlide();
            $(window).resize(function(){
                setDataLastSlide();
            });
            $slider.on('init', function(event, slick){
                setDataLastSlide();
            });

            function setDisabledNavClass(nextSlide){
                let lastSlide = $slider.attr('data-last-slide');
                if (lastSlide !== undefined) {
                    if (lastSlide <= nextSlide) {
                        $slider.addClass('_last-slide');
                    } else if (lastSlide > nextSlide) {
                        $slider.removeClass('_last-slide');
                    }
                }
            }
            setDisabledNavClass(initialSlide);
            $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                setDisabledNavClass(nextSlide);
            });

            function scrollToLastSlide(currentSlide){
                var lastSlide = $slider.attr('data-last-slide');
                if (lastSlide !== undefined && lastSlide < currentSlide) {
                    setTimeout(function(){
                        $slider.slick('slickGoTo', Number(lastSlide));
                    }, 50);
                }
            }
            scrollToLastSlide(initialSlide);
            $slider.on('afterChange', function(event, slick, currentSlide){
                scrollToLastSlide(currentSlide);
            });

        }

    };
    App.Slider.init();

});